import React, { memo } from 'react'

import { isMediaTypeImage } from '../../util/media.helpers'
import MediaPlayer from '../shared/media/MediaPlayer'
import { Image } from '../shared/image'

const RedeemAsset = ({ image, metadata, isNft }) => {
  const mediaType = metadata?.media?.type
  return (
    <>
      {image && <Image src={image} ratio='1/1' sx={{ borderRadius: 2 }} />}
      {isNft && mediaType && !isMediaTypeImage(mediaType) && (
        <MediaPlayer src={metadata?.media?.url} mediaType={mediaType} />
      )}
    </>
  )
}

export default memo(RedeemAsset)
